import { BehaviorSubject } from 'rxjs';

/**
 * Denotes whether the SessionExpired dialog is currently open.
 */
export default new BehaviorSubject(false);
